import(/* webpackMode: "eager" */ "/home/ubuntu/hs-med-billing-staging/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/hs-med-billing-staging/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/hs-med-billing-staging/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/hs-med-billing-staging/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/hs-med-billing-staging/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/hs-med-billing-staging/providers/store-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/hs-med-billing-staging/providers/theme-providers.tsx");
